import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";

import * as sharedDiscussionStyles from "#discussion-package/shared-styles.ts";

export function DiscussionsNotAvailableMessage() {
    const discussionsNotAvailable = t({
        context:
            '"Discussions" refers to a feature on the site where learners can post comments, ask and answer questions, etc. We show this message to students when their school has blocked the discussions feature, so they cannot use it while on campus.',
        message: "Discussions are not available at this time.",
    });
    return (
        <View>
            <div className={css(styles.separator)} />
            <Strut size={100} />
            <div role="status" className={css(styles.message)}>
                {discussionsNotAvailable}
            </div>
            <Strut size={300} />
        </View>
    );
}

const styles = StyleSheet.create({
    separator: {
        ...sharedDiscussionStyles.separator,
    },

    message: {
        textAlign: "center",
    },
});
